export default "__VITE_ASSET__CJDcfCbN__"